import React, { useEffect, useMemo, useRef, useState } from 'react';

import persama2024_1 from '@images/Anugerah PERSAMA 2024/cotzj9zhgk1beosqi9ii.webp';
import persama2024_2 from '@images/Anugerah PERSAMA 2024/docinhtv9tghunpuqave.webp';
import persama2024_3 from '@images/Anugerah PERSAMA 2024/kxxbvlwhykhp3jdflstn.webp';
import persama2024_4 from '@images/Anugerah PERSAMA 2024/npzgfbtctyosle7so6jq.webp';

import eduInnovate2023_1 from '@images/EDU INNOVATE UPSI 2023/IMG_2160.webp';
import eduInnovate2023_2 from '@images/EDU INNOVATE UPSI 2023/IMG_2211.webp';
import eduInnovate2023_3 from '@images/EDU INNOVATE UPSI 2023/IMG_2231.webp';
import eduInnovate2023_4 from '@images/EDU INNOVATE UPSI 2023/IMG_2233.webp';

import ereka2021_1 from '@images/EREKA 2021/DSC_2919.webp';
import ereka2021_2 from '@images/EREKA 2021/DSC_2931.webp';
import ereka2021_3 from '@images/EREKA 2021/IMG_4420.webp';

import festivalIdea2024_1 from '@images/Festival of IDEA 2024/2b99dcc5-dd22-4c9d-ae53-196cef0a9447.webp';
import festivalIdea2024_2 from '@images/Festival of IDEA 2024/4d0cf3f4-15df-4ac4-a6a2-d8dad9fc0fb1.webp';
import festivalIdea2024_3 from '@images/Festival of IDEA 2024/IMG_6545.webp';
import festivalIdea2024_4 from '@images/Festival of IDEA 2024/d2a3660c-d776-454c-8f70-e2b215388ea5.webp';

import iptexBangkok2024_1 from '@images/IPTEX Bangkok 2024/92a2eb21-ec0c-4163-b853-2d29b38bc83a.webp';
import iptexBangkok2024_2 from '@images/IPTEX Bangkok 2024/IMG_3440.webp';
import iptexBangkok2024_3 from '@images/IPTEX Bangkok 2024/IMG_3504.webp';
import iptexBangkok2024_4 from '@images/IPTEX Bangkok 2024/b4452514-d2e1-4dbe-aaaa-62f56fb20548.webp';

import pak2024_1 from '@images/Peluncuran Program Anak Kita PAK 2024/DSC01589.webp';
import pak2024_2 from '@images/Peluncuran Program Anak Kita PAK 2024/IMG_5626.webp';
import pak2024_3 from '@images/Peluncuran Program Anak Kita PAK 2024/IMG_5672.webp';
import pak2024_4 from '@images/Peluncuran Program Anak Kita PAK 2024/IMG_5710.webp';
import pak2024_5 from '@images/Peluncuran Program Anak Kita PAK 2024/IMG_5717.webp';

import schoolOutKeriang2023_1 from '@images/SCHOOL OUT KIDS IN PUSAT SAINS GUNUNG KERIANG MAY 2023/1caf3b2a-d36f-427b-9670-bcaca64af702.webp';
import schoolOutKeriang2023_2 from '@images/SCHOOL OUT KIDS IN PUSAT SAINS GUNUNG KERIANG MAY 2023/6238c4a3-ec39-48b2-9712-50874f157d6c.webp';
import schoolOutKeriang2023_3 from '@images/SCHOOL OUT KIDS IN PUSAT SAINS GUNUNG KERIANG MAY 2023/IMG_0731.webp';
import schoolOutKeriang2023_4 from '@images/SCHOOL OUT KIDS IN PUSAT SAINS GUNUNG KERIANG MAY 2023/IMG_0748.webp';

import stemSriaz2023_1 from '@images/STEM EDUCATION SRIAZ 2023/IMG_3022.webp';
import stemSriaz2023_2 from '@images/STEM EDUCATION SRIAZ 2023/IMG_3026.webp';
import stemSriaz2023_3 from '@images/STEM EDUCATION SRIAZ 2023/IMG_3030.webp';
import stemSriaz2023_4 from '@images/STEM EDUCATION SRIAZ 2023/IMG_3031.webp';

import xporiaKeriang2023_1 from '@images/XPORIA SAINS Pusat Sains Gunung Keriang 2023/IMG_3058.webp';
import xporiaKeriang2023_2 from '@images/XPORIA SAINS Pusat Sains Gunung Keriang 2023/IMG_3062.webp';
import xporiaKeriang2023_3 from '@images/XPORIA SAINS Pusat Sains Gunung Keriang 2023/IMG_3063.webp';
import xporiaKeriang2023_4 from '@images/XPORIA SAINS Pusat Sains Gunung Keriang 2023/IMG_3077.webp';

const CAT_COLORS = {
  events: '#E8302A',
  competitions: '#1A6FC4',
  workshops: '#27A84A',
  schools: '#7B3FBF',
  launches: '#C49200',
  community: '#E8652A',
};

const IMG_POOLS = {
  competitions: [],
  schools: [],
  launches: [],
  workshops: [],
  events: [],
  community: [],
};

const ITEMS = [
  {
    id: 20240601,
    cat: 'events',
    title: 'Festival of IDEA 2024',
    date: '2024',
    year: 2024,
    location: 'Malaysia',
    desc: 'Highlights from Festival of IDEA 2024.',
    attendees: '—',
    tags: ['Events', 'Festival of IDEA 2024', 'IDEA', 'Innovation'],
    popular: 75,
    imgs: [festivalIdea2024_1, festivalIdea2024_2, festivalIdea2024_3, festivalIdea2024_4],
    imgCount: 4,
  },
  {
    id: 20240415,
    cat: 'launches',
    title: 'Peluncuran Program Anak Kita PAK 2024',
    date: '2024',
    year: 2024,
    location: 'Malaysia',
    desc: 'Highlights from Peluncuran Program Anak Kita (PAK) 2024.',
    attendees: '—',
    tags: ['Launch', 'Peluncuran', 'Program Anak Kita', 'PAK', '2024'],
    popular: 72,
    imgs: [pak2024_1, pak2024_2, pak2024_3, pak2024_4, pak2024_5],
    imgCount: 5,
  },
  {
    id: 20240401,
    cat: 'events',
    title: 'Anugerah PERSAMA 2024',
    date: '2024',
    year: 2024,
    location: 'Malaysia',
    desc: 'Highlights from Anugerah PERSAMA 2024.',
    attendees: '—',
    tags: ['Events', 'Anugerah PERSAMA 2024', 'PERSAMA', 'Awards'],
    popular: 80,
    imgs: [persama2024_1, persama2024_2, persama2024_3, persama2024_4],
    imgCount: 4,
  },
  {
    id: 20240201,
    cat: 'competitions',
    title: 'IPTEX Bangkok 2024',
    date: '2024',
    year: 2024,
    location: 'Bangkok, Thailand',
    desc: 'Highlights from IPTEX Bangkok 2024.',
    attendees: '—',
    tags: ['Competition', 'IPTEX', 'Bangkok', 'Thailand', '2024'],
    popular: 85,
    imgs: [iptexBangkok2024_1, iptexBangkok2024_2, iptexBangkok2024_3, iptexBangkok2024_4],
    imgCount: 4,
  },
  {
    id: 20230801,
    cat: 'workshops',
    title: 'STEM EDUCATION SRIAZ 2023',
    date: '2023',
    year: 2023,
    location: 'SRIAZ, Malaysia',
    desc: 'Hands-on STEM education session at SRIAZ (2023).',
    attendees: '—',
    tags: ['Workshop', 'STEM', 'Education', 'SRIAZ', '2023'],
    popular: 68,
    imgs: [stemSriaz2023_1, stemSriaz2023_2, stemSriaz2023_3, stemSriaz2023_4],
    imgCount: 4,
  },
  {
    id: 20230601,
    cat: 'community',
    title: 'XPORIA SAINS Pusat Sains Gunung Keriang 2023',
    date: '2023',
    year: 2023,
    location: 'Pusat Sains Gunung Keriang, Malaysia',
    desc: 'Highlights from XPORIA SAINS at Pusat Sains Gunung Keriang (2023).',
    attendees: '—',
    tags: ['Community', 'XPORIA SAINS', 'Science', 'Gunung Keriang', '2023'],
    popular: 69,
    imgs: [xporiaKeriang2023_1, xporiaKeriang2023_2, xporiaKeriang2023_3, xporiaKeriang2023_4],
    imgCount: 4,
  },
  {
    id: 20230501,
    cat: 'schools',
    title: 'SCHOOL OUT KIDS IN PUSAT SAINS GUNUNG KERIANG MAY 2023',
    date: 'May 2023',
    year: 2023,
    location: 'Pusat Sains Gunung Keriang, Malaysia',
    desc: 'School outing at Pusat Sains Gunung Keriang (May 2023).',
    attendees: '—',
    tags: ['School', 'School Out', 'Kids', 'Science Centre', 'Gunung Keriang', 'May 2023'],
    popular: 66,
    imgs: [schoolOutKeriang2023_1, schoolOutKeriang2023_2, schoolOutKeriang2023_3, schoolOutKeriang2023_4],
    imgCount: 4,
  },
  {
    id: 20230301,
    cat: 'events',
    title: 'EDU INNOVATE UPSI 2023',
    date: '2023',
    year: 2023,
    location: 'Malaysia',
    desc: 'Highlights from EDU INNOVATE UPSI 2023.',
    attendees: '—',
    tags: ['Events', 'EDU INNOVATE UPSI 2023', 'UPSI', 'Innovation'],
    popular: 70,
    imgs: [eduInnovate2023_1, eduInnovate2023_2, eduInnovate2023_3, eduInnovate2023_4],
    imgCount: 4,
  },
  {
    id: 20211001,
    cat: 'events',
    title: 'EREKA 2021',
    date: '2021',
    year: 2021,
    location: 'Malaysia',
    desc: 'Highlights from EREKA 2021.',
    attendees: '—',
    tags: ['Events', 'EREKA', '2021', 'Innovation'],
    popular: 55,
    imgs: [ereka2021_1, ereka2021_2, ereka2021_3],
    imgCount: 3,
  },
];

function catLabel(cat) {
  return (
    {
      events: 'Event',
      competitions: 'Competition',
      workshops: 'Workshop',
      schools: 'School',
      launches: 'Launch',
      community: 'Community',
    }[cat] || cat
  );
}

function getImgs(item) {
  if (item.imgs && item.imgs.length) return item.imgs;
  const pool = IMG_POOLS[item.cat] || IMG_POOLS.events;
  return pool.slice(0, item.imgCount);
}

function getCollageClass(imgCount) {
  const n = Math.min(imgCount, 4);
  return ['', '', 'c2', 'c3', 'c4'][n] || '';
}

const Gallery = () => {
  const [currentFilter, setCurrentFilter] = useState('all');
  const [currentSearch, setCurrentSearch] = useState('');
  const [currentSort, setCurrentSort] = useState('newest');
  const [isListView, setIsListView] = useState(false);
  const [favorites, setFavorites] = useState(() => new Set());
  const [totalEvents, setTotalEvents] = useState(0);

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lbEventIdx, setLbEventIdx] = useState(0);
  const [lbImgIdx, setLbImgIdx] = useState(0);
  const [scrollTopVisible, setScrollTopVisible] = useState(false);
  const bodyLockRef = useRef({ overflow: '', paddingRight: '' });

  const filteredItems = useMemo(() => {
    let list = [...ITEMS];

    if (currentFilter !== 'all') {
      list = list.filter((i) => i.cat === currentFilter);
    }

    if (currentSearch.trim()) {
      const q = currentSearch.trim().toLowerCase();
      list = list.filter(
        (i) =>
          i.title.toLowerCase().includes(q) ||
          i.location.toLowerCase().includes(q) ||
          i.desc.toLowerCase().includes(q) ||
          i.tags.some((t) => t.toLowerCase().includes(q))
      );
    }

    if (currentSort === 'newest') list.sort((a, b) => b.year - a.year || b.id - a.id);
    if (currentSort === 'oldest') list.sort((a, b) => a.year - b.year || a.id - b.id);
    if (currentSort === 'alpha') list.sort((a, b) => a.title.localeCompare(b.title));
    if (currentSort === 'popular') list.sort((a, b) => b.popular - a.popular);

    return list;
  }, [currentFilter, currentSearch, currentSort]);

  const lightboxItem = filteredItems[lbEventIdx];
  const lightboxImgs = lightboxItem ? getImgs(lightboxItem) : [];

  const countAnimRef = useRef({ raf: 0 });

  useEffect(() => {
    const el = { value: 0 };
    const target = ITEMS.length;
    const durationMs = 900;
    const start = performance.now();

    const tick = (now) => {
      const t = Math.min((now - start) / durationMs, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      el.value = Math.round(eased * target);
      setTotalEvents(el.value);
      if (t < 1) countAnimRef.current.raf = requestAnimationFrame(tick);
    };

    countAnimRef.current.raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(countAnimRef.current.raf);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrollTopVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!lightboxOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setLightboxOpen(false);
      if (e.key === 'ArrowLeft') {
        setLbEventIdx((prev) => {
          const next = (prev - 1 + filteredItems.length) % filteredItems.length;
          setLbImgIdx(0);
          return next;
        });
      }
      if (e.key === 'ArrowRight') {
        setLbEventIdx((prev) => {
          const next = (prev + 1) % filteredItems.length;
          setLbImgIdx(0);
          return next;
        });
      }
    };

    document.addEventListener('keydown', onKeyDown);
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    bodyLockRef.current.overflow = document.body.style.overflow;
    bodyLockRef.current.paddingRight = document.body.style.paddingRight;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = scrollbarWidth ? `${scrollbarWidth}px` : bodyLockRef.current.paddingRight;

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = bodyLockRef.current.overflow;
      document.body.style.paddingRight = bodyLockRef.current.paddingRight;
    };
  }, [filteredItems.length, lightboxOpen]);

  useEffect(() => {
    if (!lightboxOpen || !lightboxImgs.length) return;
    const indicesToPreload = new Set([
      lbImgIdx,
      (lbImgIdx + 1) % lightboxImgs.length,
      (lbImgIdx - 1 + lightboxImgs.length) % lightboxImgs.length,
    ]);

    indicesToPreload.forEach((i) => {
      const src = lightboxImgs[i];
      if (!src) return;
      const img = new Image();
      img.decoding = 'async';
      img.src = src;
    });
  }, [lightboxOpen, lightboxImgs, lbImgIdx]);

  useEffect(() => {
    if (!lightboxOpen) return;
    if (!filteredItems.length) setLightboxOpen(false);
    if (lbEventIdx >= filteredItems.length) setLbEventIdx(0);
  }, [filteredItems.length, lightboxOpen, lbEventIdx]);

  const openLightbox = (eventIndex, imageIndex) => {
    setLbEventIdx(eventIndex);
    setLbImgIdx(imageIndex);
    setLightboxOpen(true);
  };

  const toggleFavorite = (id) => {
    setFavorites((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const categories = [
    { key: 'all', label: 'All' },
    { key: 'events', label: '🎉 Events' },
    { key: 'competitions', label: '🏆 Competitions' },
    { key: 'workshops', label: '🛠 Workshops' },
    { key: 'schools', label: '🏫 Schools' },
    { key: 'launches', label: '🚀 Launches' },
    { key: 'community', label: '🌍 Community' },
  ];

  return (
    <div className="damat-gallery">
      <section className="hero">
        <div className="hero-badge">📸 Our Journey in Photos</div>
        <h1>
          Events, Activities
          <br />&amp; <span className="accent">Memories</span>
        </h1>
        <p>
          From national championships to school workshops — explore the moments that make DAMAT more than just a game.
        </p>
        <div className="stats-row" aria-label="Gallery stats">
          <div className="stat-item">
            <span className="stat-num">{totalEvents}</span>
            <span className="stat-label">Events</span>
          </div>
          <div className="stat-item">
            <span className="stat-num">174+</span>
            <span className="stat-label">Schools</span>
          </div>
          <div className="stat-item">
            <span className="stat-num">3,500+</span>
            <span className="stat-label">Students</span>
          </div>
        </div>
      </section>

      <div className="toolbar">
        <div className="tb-row1">
          <div className="search-wrap">
            <svg className="search-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <input
              className="search-input"
              type="text"
              value={currentSearch}
              onChange={(e) => setCurrentSearch(e.target.value)}
              placeholder="Search events, locations…"
              aria-label="Search gallery"
            />
          </div>
          <div className="tb-spacer" />
          <span className="tb-label">Sort by</span>
          <select
            className="sort-select"
            value={currentSort}
            onChange={(e) => setCurrentSort(e.target.value)}
            aria-label="Sort gallery"
          >
            <option value="newest">Newest First</option>
            <option value="oldest">Oldest First</option>
            <option value="alpha">A – Z</option>
            <option value="popular">Most Popular</option>
          </select>
          <div className="view-toggle" role="tablist" aria-label="View mode">
            <button
              type="button"
              className={`view-btn ${!isListView ? 'active' : ''}`}
              onClick={() => setIsListView(false)}
              aria-pressed={!isListView}
              title="Grid"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="7" height="7" rx="1" />
              </svg>
            </button>
            <button
              type="button"
              className={`view-btn ${isListView ? 'active' : ''}`}
              onClick={() => setIsListView(true)}
              aria-pressed={isListView}
              title="List"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                <line x1="4" y1="6" x2="20" y2="6" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="4" y1="18" x2="20" y2="18" />
              </svg>
            </button>
          </div>
        </div>

        <div className="tb-row2" role="tablist" aria-label="Category filters">
          {categories.map((c, idx) => (
            <React.Fragment key={c.key}>
              {idx === 1 ? <div className="tb-divider" /> : null}
              <button
                type="button"
                className={`pill ${currentFilter === c.key ? 'active' : ''}`}
                data-cat={c.key}
                onClick={() => setCurrentFilter(c.key)}
              >
                {c.label}
              </button>
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="results-bar">
        <p className="results-count">
          Showing <strong>{filteredItems.length}</strong> results
        </p>
      </div>

      <div className="gallery-container">
        {filteredItems.length ? (
          <div className={`gallery-grid ${isListView ? 'list-view' : ''}`}>
            {filteredItems.map((item, idx) => {
              const imgs = getImgs(item);
              const n = Math.min(imgs.length, 4);
              const collageClass = getCollageClass(n);
              const isFav = favorites.has(item.id);
              return (
                <div
                  key={item.id}
                  className="card"
                  style={{ animationDelay: `${Math.min(idx * 50, 360)}ms` }}
                  onClick={(e) => {
                    if (e.target.closest('button')) return;
                    openLightbox(idx, 0);
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') openLightbox(idx, 0);
                  }}
                >
                  <div className={`collage ${collageClass}`} style={{ height: '210px' }}>
                    {imgs.slice(0, 4).map((src) => (
                      <div key={src} className="ci">
                        <img src={src} alt="" loading="lazy" decoding="async" />
                      </div>
                    ))}
                    <div className="collage-overlay">
                      <button
                        type="button"
                        className="overlay-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          openLightbox(idx, 0);
                        }}
                      >
                        View Photos →
                      </button>
                    </div>
                    <span className={`cat-badge cat-${item.cat}`}>{catLabel(item.cat)}</span>
                    <span className="img-count">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                      >
                        <rect x="3" y="3" width="18" height="18" rx="2" />
                        <circle cx="8.5" cy="8.5" r="1.5" />
                        <polyline points="21 15 16 10 5 21" />
                      </svg>
                      {n}
                    </span>
                  </div>
                  <div className="card-body">
                    <h3 className="card-title">{item.title}</h3>
                    <p className="card-desc">{item.desc}</p>
                    <div className="card-meta">
                      <div className="meta-info">
                        <span className="meta-row">
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <rect x="3" y="4" width="18" height="18" rx="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                          </svg>
                          {item.date}
                        </span>
                        <span className="meta-row">
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                            <circle cx="12" cy="10" r="3" />
                          </svg>
                          {item.location.split(',')[0]}
                        </span>
                      </div>
                      <div className="meta-actions">
                        <span className="att-pill">👥 {item.attendees}</span>
                        <button
                          type="button"
                          className={`fav-btn ${isFav ? 'active' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleFavorite(item.id);
                          }}
                          aria-pressed={isFav}
                          aria-label={isFav ? 'Remove from favorites' : 'Add to favorites'}
                        >
                          ♥
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-state visible">
            <div style={{ fontSize: '2.5rem', marginBottom: '.75rem', opacity: 0.4 }}>🔍</div>
            <h3>No results found</h3>
            <p>Try a different keyword or filter.</p>
          </div>
        )}
      </div>

      <div
        className={`lightbox ${lightboxOpen ? 'open' : ''}`}
        onClick={(e) => {
          if (e.target.classList.contains('lightbox')) setLightboxOpen(false);
        }}
        aria-hidden={!lightboxOpen}
      >
        <div className="lb-panel" role="dialog" aria-modal="true" aria-label="Gallery photos">
          <div className="lb-img-area">
            <img
              className="lb-main-img"
              src={lightboxImgs[lbImgIdx] || ''}
              alt=""
              decoding="async"
              fetchPriority="high"
              draggable={false}
            />
            <button type="button" className="lb-close" onClick={() => setLightboxOpen(false)} aria-label="Close">
              ✕
            </button>
            <button
              type="button"
              className="lb-nav-btn lb-prev"
              onClick={() => {
                if (!filteredItems.length) return;
                setLbEventIdx((prev) => {
                  const next = (prev - 1 + filteredItems.length) % filteredItems.length;
                  setLbImgIdx(0);
                  return next;
                });
              }}
              aria-label="Previous event"
            >
              ‹
            </button>
            <button
              type="button"
              className="lb-nav-btn lb-next"
              onClick={() => {
                if (!filteredItems.length) return;
                setLbEventIdx((prev) => {
                  const next = (prev + 1) % filteredItems.length;
                  setLbImgIdx(0);
                  return next;
                });
              }}
              aria-label="Next event"
            >
              ›
            </button>
          </div>

          <div className="lb-thumbs">
            {lightboxImgs.map((src, i) => (
              <button
                type="button"
                key={src}
                className={`lb-thumb ${i === lbImgIdx ? 'active' : ''}`}
                onClick={() => setLbImgIdx(i)}
                aria-label={`View photo ${i + 1}`}
              >
                <img src={src} alt="" loading="lazy" decoding="async" draggable={false} />
              </button>
            ))}
          </div>

          <div className="lb-body">
            {lightboxItem ? (
              <>
                <span className="lb-cat" style={{ background: CAT_COLORS[lightboxItem.cat] || '#888' }}>
                  {catLabel(lightboxItem.cat)}
                </span>
                <h2 className="lb-title">{lightboxItem.title}</h2>
                <div className="lb-details">
                  <span className="lb-detail">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    {lightboxItem.date}
                  </span>
                  <span className="lb-detail">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    {lightboxItem.location}
                  </span>
                  <span className="lb-detail">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                    </svg>
                    {lightboxItem.attendees} attendees
                  </span>
                </div>
                <p className="lb-desc">{lightboxItem.desc}</p>
                <div className="lb-tags">
                  {lightboxItem.tags.map((t) => (
                    <span key={t} className="lb-tag">
                      {t}
                    </span>
                  ))}
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>

      <button
        type="button"
        className={`scroll-top ${scrollTopVisible ? 'visible' : ''}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Scroll to top"
      >
        ↑
      </button>
    </div>
  );
};

export default Gallery;
